const entryPageValues = {
  // Promo page
  PROMO_LISTING_PAGE: 'Promo Listing Page',
  PROMO_DETAIL_PAGE: 'Promo Detail Page',

  // News page
  NEWS_LISTING_PAGE: 'News and Tips Listing Page',
  NEWS_DETAIL_PAGE: 'News and Tips Detail Page',

  // Product review page
  PRODUCT_REVIEW_LISTING_PAGE: 'Product Review Listing Page',
  PRODUCT_REVIEW_DETAIL_PAGE: 'Product Review Detail Page',

  // New car page
  NEW_CAR_LISTING_PAGE: 'New Car Listing Page',
  NEW_CAR_DETAIL_PAGE: 'New Car Detail Page',
  NEW_CAR_COMPARISON_PAGE: 'New Car Comparison Page',

  // Used car page
  USED_CAR_LISTING_PAGE: 'Used Car Listing Page',
  USED_CAR_DETAIL_PAGE: 'Used Car Detail Page',
  USED_CAR_COMPARISON_PAGE: 'Used Car Compare Page',
  USED_CAR_PREORDER_PAGE: 'Used Car Preorder Page',
  USED_CAR_LANDING_PAGE: 'Used Car Landing Page',

  // Landing page
  CITY_LISTING_LANDING_PAGE: 'City Listing Landing Page',
  CITY_NEWS_LISTING_PAGE: 'City News Listing Page',
  CITY_NEWS_DETAIL_PAGE: 'City News Detail Page',
  CITY_PROMO_LISTING_PAGE: 'City Promo Listing Page',
  CITY_PROMO_DETAIL_PAGE: 'City Promo Detail Page',
  BRANCH_DETAIL_LANDING_PAGE: 'Branch Detail Landing Page',
  BRANCH_NEWS_LISTING_PAGE: 'Branch News Listing Page',
  BRANCH_NEWS_DETAIL_PAGE: 'Branch News Detail Page',
  BRANCH_PROMO_LISTING_PAGE: 'Branch Promo Listing Page',
  BRANCH_PROMO_DETAIL_PAGE: 'Branch Promo Detail Page',
  ACCOUNT_EXECUTIVE_LISTING_PAGE: 'Account Executive Listing Page',
  ACCOUNT_EXECUTIVE_DETAIL_PAGE: 'Account Executive Detail Page',
  ACCOUNT_EXECUTIVE_NEWS_DETAIL_PAGE: 'Account Executive News Detail Page',
  ACCOUNT_EXECUTIVE_PROMO_DETAIL_PAGE: 'Account Executive Promo Detail Page',
};

export default entryPageValues;
